import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Inject } from '@angular/core';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatTooltipModule } from '@angular/material/tooltip';

import { FadeTextOnWidthDirective } from '@shared/directives/fade-text-on-width.directive';

export interface TemplateDescriptionDialogData {
  description: string;
  editMode: boolean;
  templateTitle: string;
}

const TEMPLATE_DESCRIPTION_MAX_LENGTH = 1000;

@Component({
  selector: 'app-template-description-modal',
  templateUrl: './template-description-modal.component.html',
  styleUrls: ['./template-description-modal.component.scss'],
  standalone: true,
  imports: [
    CommonModule,
    MatDialogModule,
    ReactiveFormsModule,
    MatButtonModule,
    FadeTextOnWidthDirective,
    MatTooltipModule,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TemplateDescriptionModalComponent {
  descriptionControl = new FormControl();
  maxLength = TEMPLATE_DESCRIPTION_MAX_LENGTH;

  constructor(
    public dialogRef: MatDialogRef<TemplateDescriptionModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: TemplateDescriptionDialogData
  ) {
    this.descriptionControl.setValue(data.description || null);
  }

  onSave(): void {
    this.dialogRef.close({ confirmed: true, value: this.descriptionControl.value });
  }
}
